import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CadastreHeader from "../headers/cadastre.header";
import PurveyorCadastreForm from "./forms/purveyor.cadastre.form";
import PurveyorCadastreList from "./lists/purveyor.cadastre.list";
import { useTranslateContext } from "../../contexts/translate.context";

export interface IPurveyorCadastreProps {
}

export const PurveyorCadastre: React.FC<IPurveyorCadastreProps> = (props: IPurveyorCadastreProps) => {

    const { purveyorId } = useParams();
    const { display } = useTranslateContext();

    const title = display.title.purveyor;
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : purveyorId || '', selected : ((purveyorId === 'new') || (purveyorId === '0') || (!Number.isNaN(Number.parseInt(purveyorId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
    
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);
    
    return (
        <div className="page">
            <CadastreHeader title="Fornecedores" description={description} />
            {(recordSelected.selected) ? (
                <PurveyorCadastreForm 
                    title={title}
                    purveyorId={recordSelected.param}
                    setRecord={(event: any) => { 
                        event.preventDefault();
        
                        setSelected(false, '0'); 
                    }} />
            ) : (
                <PurveyorCadastreList
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
        
                        setSelected(true, recordId); 
                    }} />
            )}
        </div>
    )
}

export default PurveyorCadastre;
